import useMedia from 'syf-js-utilities/hooks/useMedia';
import useInnerWidth from 'syf-js-utilities/hooks/useInnerWidth';
import mediaQueries from '../../const/mediaQueries';
const useWindowSize = () => {
    const matchedWindowSize = useMedia([
        mediaQueries.lessThanSmall,
        mediaQueries.lessThanMedium,
        mediaQueries.lessThanLarge,
        mediaQueries.lessThanHuge
    ], [
        'isLessThanMobile',
        'isLessThanTablet',
        'isLessThanDesktop',
        'isLessThanXLarge'
    ], 'other');
    const width = useInnerWidth();
    const windowSize = {
        isLessThanMobile: false,
        isLessThanTablet: false,
        isLessThanDesktop: false,
        isLessThanXLarge: false,
        width
    };
    if (matchedWindowSize === 'isLessThanMobile') {
        windowSize.isLessThanMobile = true;
        windowSize.isLessThanTablet = true;
        windowSize.isLessThanDesktop = true;
        windowSize.isLessThanXLarge = true;
    }
    else if (matchedWindowSize === 'isLessThanTablet') {
        windowSize.isLessThanTablet = true;
        windowSize.isLessThanDesktop = true;
        windowSize.isLessThanXLarge = true;
    }
    else if (matchedWindowSize === 'isLessThanDesktop') {
        windowSize.isLessThanDesktop = true;
        windowSize.isLessThanXLarge = true;
    }
    else if (matchedWindowSize === 'isLessThanXLarge') {
        windowSize.isLessThanXLarge = true;
    }
    return windowSize;
};
export default useWindowSize;
